import { useCallback, useContext, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import { ActivityCauserType } from '~/core/shared/types';
import { ApplicationContext } from '../../../../Layout.component';

export const useActivitiesTab = () => {
  const { applicationUuid, definition } = useContext(ApplicationContext);
  const [causerType, setCauserType] = useState<
    ActivityCauserType | undefined
  >();
  const form = useForm({});
  const [search, beforeDate, afterDate] = form.watch([
    'search',
    'before_date',
    'after_date',
  ]);

  const onSearch = useCallback(
    (value: string) => {
      form.setValue('search', value);
    },
    [form.setValue],
  );

  const searchParams = useMemo(
    () => ({
      search,
      causerType,
      beforeDate,
      afterDate,
    }),
    [search, causerType, beforeDate, afterDate],
  );

  return {
    form,
    onSearch,
    causerType,
    setCauserType,
    definition,
    applicationUuid,
    searchParams,
  };
};
